<template>
    <div class="searchWrap">
        <!-- 移动端返回键 -->
        <div class="return">
            <p @click="toReturn"></p>
        </div>
        <!-- 输入框 -->
        <div class="inputWrap">
            <div class="inputBox">
                <img src="../../assets/img/search_icon1.svg" class="searchIcon"  :style="searchBg?'display:block;':'display:none;'"/>
                <input type="text" class="iconfont" placeholder='输入关键词搜索' v-model="value" @input="showClear" @keyup.enter="searchFn('search')">
                <img src="../../assets/img/clear.svg" class="clearIcon" v-show="showClearBtn" @click="clearVal">
            </div>
            <p :style="searchBg?'background: rgba(25,25,26,0.40);':'background: #0061FE;'" @click="searchFn('search')">搜索</p>
        </div>
        <!-- 未搜索前 -->
        <div class="inputBlank" v-if="searchContShow"></div>
        <!-- 搜索后 -->
        <div class="searchEnter" v-else>
            <!-- 空白页 -->
            <div class="blank" v-if="showBlankPage">
                <img src="../../assets/img/search_blank.png" />
                <p class="iconfont">没有找到相关内容,换个关键词试试</p>
            </div>
            <!-- 搜索到的内容 -->
            <div class="searchCont" v-else>
                <div class="mindCont">
                    <div class="classify_nav">
                        <p :class="allActive?'router-link-active':''" @click="searchFn">全部</p>
                        <p v-for="(item,index) in navList" :key="index" :class="allActive?'':(active==index?'router-link-active':'')" @click="getDataFn(item.ID,index)">{{item.Name}}{{'('+item.Num+')'}}</p>
                    </div>
                </div>
                <!-- 列表 -->
                <ul class="listWrap">
                    <li v-for="(item,index) in searchList" :key="index">
                        <router-link :to="{path:'/classDetial', query:{courseId:item.ID}}" @click.native="saveID(item.ID)">
                            <div class="picBox">
                                <img :src="item.ImgPath" />
                                <p><span>{{item.Score}}</span><span>学分</span></p>
                            </div>
                            <div class="infoWrap">
                                <p class="category"><span>{{item.Keywords}}</span></p>
                                <h2>{{item.Title}}</h2>
                                <div class="info">
                                    <p>时长：<span>{{item.Duration}}</span></p>
                                    <p>播放：<span>{{item.Hits}}</span></p>
                                    <p>日期：<span>{{item.PubDate | formatData}}</span></p>
                                </div>
                            </div>
                            <div class="head-zan">
                                <p class="head"><img src="../../assets/img/speaker.jpg" /><span>{{item.LectureName}}</span></p>
                                <div class="zan"><p><img src="../../assets/img/zanBefore.svg" /></p><span>{{item.Tags}}</span></div>
                            </div>
                        </router-link>
                    </li>
                </ul>
                <!-- 分页器 -->
                <div class="page"><Pagination :total='totalPage' :page="page" :pageSize = 'pagesize' @currentPage="currentPage"></Pagination></div>
                <!-- 移动端 -->
                <p class="moreCourse" v-if="isShowMore" @click="getMore">更多课程</p>
            </div>
        </div>
    </div>
</template>

<script>
import Pagination from '../../components/Pagination'
import '../../assets/js/formatTime'
export default {
    data() {
        return {
            fontIcon:'\ue63c',
            value:'',  // input值
			searchValue:'',  // 搜索值
            showClearBtn:false,  // 显示清空键
            showBlankPage:true,  // 显示空白页
            totalPage:0,  // 总页数
            page:1,  // 页数
            pagesize:9,  // 多少条数据
            searchList:[],  // 列表
            navList:[],  // 导航列表
            navAllList:[],  // 导航全部列表
            active:0,  // 控制分类的背景
            allActive:true,  // 控制全部or分类的背景
            flId:undefined,  // 分类id
            searchBg:true,  // 搜索背景
            searchContShow:true,  // 搜索前后显示的内容
            isShowMore:true  // 是否显示更多
        }
    },
    mounted(){
        // 获取课程分类
        this.getClassifyList();

        // 从详细页返回时，获取课程列表
        let kcData = null;
        let type = this.$route.query.type;
        if(type != undefined){
            // 空白页隐藏
            this.searchContShow = false;
            this.showBlankPage = false;
            this.searchBg = false;
            // 获取相关参数
            let listParams = JSON.parse(sessionStorage.getItem('searchListParams'));
            this.navList = listParams.navList;
            this.flId = listParams.flIdNum ? JSON.parse(listParams.flIdNum) : undefined;
            this.value = this.fontIcon + listParams.searchVal;
            // 当移动端点击查看更多后 进入详情，返回时让page为1，以避免当page大于1时，前几页的数据看不到
            if(sessionStorage.getItem('lookMore') == '1'){
                this.page = 1;
                sessionStorage.removeItem('lookMore');
            }else{
                this.page = listParams.pageNum;
            }
            // console.log(typeof(this.flId),JSON.parse(sessionStorage.getItem('flIdNum')),val,this.page,this.flId)
            // 如果分类为null时，就显示全部数据
            if(typeof(this.flId) == "number"){
                this.allActive = false;
                this.active = listParams.activeFl;
                
                this.getData();
                // console.log('!=null',this.active)
            }else{
                this.searchFn();
            }
        }
    },
    methods: {
		// 获取课程分类列表
		getClassifyList(){
			let timestamp = Date.parse(new Date())/1000;
			let data = {
			    "TimeStamp":timestamp,
			    "ID":0
			}
			this.$axios.post(Const_Api_Root+'api/Course/QueryItems',data,{
				contentType: 'application/json',
			    dateType:'JSON',
			    xHrFields: {withCredentials:true},
				beforeSend: function (XHR) {
					XHR.withCredentials = true;  // 跨域cookie支持代码
				}
			}).then((res)=>{
			    // 错误提示
			    if(res.data.Status == 0){
			        this.navAllList = res.data.Data[0].Childs;
			    }else if(res.data.Status != -2){
			        this.$message({
			            message: res.data.Data,
			            type: 'error',
			            duration: 3000
			        });
			    }
			}).catch((err)=>{
			    throw err;
			});
		},
        // 清空值
        clearVal(){
            this.value = '';
			this.navList = [];
			this.searchList = [];
			this.showBlankPage = true;
            this.showClearBtn = false;
            this.searchBg = true;
        },
        // 是否显示清空键
        showClear(){
            this.searchBg = false;
            if(this.value.indexOf(this.fontIcon) == -1){
                this.value = this.fontIcon + this.value;
            }
            if(this.value == ''){
                this.showClearBtn = false;
                this.flag = false;
            }else{
                this.showClearBtn = true
                this.flag = true;
            }
        },
        // 分类
        getDataFn(id,index){
            this.page = 1;
            this.flId = id;
            // 分类
            this.active = 0
            this.allActive = false;
            this.active = this.active+index;
            this.getData();
        },
        // 搜索==获取全部列表数据
        searchFn(type){
            this.searchContShow = false;
            if(this.searchValue == '') {
				this.searchValue = this.value.substring(1);
            }

            this.allActive = true;
            this.flId = null;
            // 获取unix时间戳到秒
            let timestamp = Date.parse(new Date())/1000;
            let data = {
                "TimeStamp":timestamp,
                "Sort": 1, 
                "Query": [{"Item":"SearchKey","Value":this.searchValue}],
                "PageSize":this.pagesize,
                "CurPage":this.page
            }
            this.$axios.post(Const_Api_Root+'api/Course/List',data,{
                contentType: 'application/json',
                dateType:'JSON',
                xHrFields: {withCredentials:true},
				beforeSend: function (XHR) {
					XHR.withCredentials = true;  // 跨域cookie支持代码
				}
            }).then((res)=>{
                // console.log(res)
                // 错误提示
                if(res.data.Status == 0){
                    if(res.data.Data.Total == 0){
                        this.showBlankPage = true;
                    }else{
                        this.totalPage = res.data.Data.Total;
                        this.showBlankPage = false;
                        if(type == 'search'){
                            this.navList = res.data.Data.Exts;
                            // 过滤分类列表
                            for(let m=0;m<this.navAllList.length;m++){
                                for(let n=0;n<this.navList.length;n++){
                                    if(this.navAllList[m].ID == this.navList[n].ID){
                                        this.navList[n].Name = this.navAllList[m].Name;
                                    }
                                }
                            }
                            this.searchList = res.data.Data.Rows;
                        }else if(type == 'more'){
                            // 移动端的操作
                            this.searchList = this.searchList.concat(res.data.Data.Rows);
                        }else{
                            this.searchList = res.data.Data.Rows;
                        }

                        // 是否显示查看更多
                        if(this.totalPage != this.searchList.length){
                            this.isShowMore = true;
                        }else{
                            this.isShowMore = false;
                        }
                        // 格式化关键词
                        for(let i=0;i<this.searchList.length;i++){
                            let keyWord = this.searchList[i].Keywords;
                            if(keyWord != undefined){
                                this.searchList[i].Keywords = keyWord.toString();
                            }
                        }
                    }
                }else if(res.data.Status != -2){
                    this.$message({
                        message: res.data.Data,
                        type: 'error',
                        duration: 3000
                    });
                }
            }).catch((err)=>{
                throw err;
            });
        },
         // 获取分类列表数据
        getData(type){
			let timestamp = Date.parse(new Date())/1000;
			if(this.searchValue == ''){
				this.searchValue = this.value.substring(1);
			}
			let data = {
				"TimeStamp":timestamp,
				"Sort": 1,
				"Query": [{"Item":"Kind","Value":this.flId},{"Item":"SearchKey","Value":this.searchValue}],
				"PageSize":this.pagesize,
				"CurPage":this.page
			}
            this.$axios.post(Const_Api_Root+'api/Course/List',data,{
                contentType: 'application/json',
                dateType:'JSON',
                xHrFields: {withCredentials:true},
				beforeSend: function (XHR) {
					XHR.withCredentials = true;  // 跨域cookie支持代码
				}
            }).then((res)=>{
                // console.log(res)
                // 错误提示
                if(res.data.Status == 0){
                    this.totalPage = res.data.Data.Total;
                    if(type == 'more'){
                        // 移动端的操作
                        this.searchList = this.searchList.concat(res.data.Data.Rows);
                    }else{
                        // 列表
                        this.searchList = res.data.Data.Rows;
                    }
                    // 是否显示查看更多
                    if(this.totalPage != this.searchList.length){
                        this.isShowMore = true;
                    }else{
                        this.isShowMore = false;
                    }
                    // 格式化关键词
                    for(let i=0;i<this.searchList.length;i++){
                        let keyWord = this.searchList[i].Keywords;
                        if(keyWord != undefined){
                            this.searchList[i].Keywords = keyWord.toString();
                        }
                    }
                }else if(res.data.Status != -2){
                    this.$message({
                        message: res.data.Data,
                        type: 'error',
                        duration: 3000
                    });
                }
            }).catch((err)=>{
                throw err;
            });
        },
        // 分页器
        currentPage(index){
            this.page = index;
            if(this.allActive){
                this.searchFn();
            }else{
                this.getData();
            }
        },
        // 移动端的获取更多
        getMore(){
            this.page++;
            if(this.allActive){
                this.searchFn('more');
            }else{
                this.getData('more');
            }
            sessionStorage.setItem('lookMore','1');
        },
        // 保存id
        saveID(id){
			if(this.searchValue == ''){
				this.searchValue = this.value.substring(1);
			}
            sessionStorage.setItem('courseID',id);
            sessionStorage.setItem('returnPage',"search");
            let parameter = {
                'pageNum':this.page,
                'flIdNum':this.flId,
                'activeFl':this.active,
                'searchVal':this.searchValue,
                'navList':this.navList
            }
            sessionStorage.setItem("searchListParams",JSON.stringify(parameter));
        },
        // 移动端返回
        toReturn(){
            window.history.go(-1);
            // this.$router.push({path: '/index'});
        }
    },
    filters: {
        // 格式化时间
        formatData:(value) => {
            value = new Date(value).Format("yyyy-MM-dd")
            return value;
        }
    },
    components: {
        Pagination
    }
}
</script>

<style scoped lang="less">
// 字体图标
@import url('../../assets/css/iconfont.css');

@media screen and (min-width: 320px) and (max-width: 1024px) {
    .moreCourse{
        font-size: 14px;
        color: #0061FE;
        text-align: center;
        font-weight: bold;
        padding: 20px 0;
    }
    .page{
        display: none;
    }
    .searchWrap{
        width: 100%;
        box-sizing: border-box;
        padding: 0 17px;
        // 返回
        .return{
            height: 60px;
            display: flex;
            align-items: center;
            p{
                width: 30px;
                height: 30px;
                background: url('../../assets/img/nav_return.svg') no-repeat;
                background-size: 100% 100%;
            }
        }
        // 搜索框
        .inputWrap{
            width: 100%;
            padding: 22px 0;
            margin-bottom: 71px;
            .inputBox{
                input{
                    font-size: 20px;
                    color: #19191a;
                }
            }
            .searchIcon{
                position: absolute;
                top: 50%;
                left: 15%;
                transform: translateY(-50%);
            }
            .clearIcon{
                position: absolute;
                right: 0;
                top: 8px;
            }
        }
        .inputBlank{
            width: 100%;
            height: 400px;
        }
        // 搜索到的内容
        .searchCont {
            margin-bottom: 0;
            .title{
                display: none;
            }
            .page{
                display: none;
            }
        }
        .listWrap{
            justify-content: center;
            li{
                width: 100%;
                margin-bottom: 40px;
                .picBox,.picBox img{
                    max-height: 400px;
                }
            }
        }
    }
    // 空白页
    .blank{
        width: 100%;
        text-align: center;
        img{
            width: 300px;
            height: 200px;
        }
        p{
            font-size: 16px;
            color: rgba(25,25,26,0.20);
            margin-top: 22px;
        }
    }
    // 导航
    .mindCont{
        width: 100%;
        .classify_nav{
            width: 100%;
            overflow: hidden;
            overflow-x: scroll;
            white-space:nowrap;
            font-size: 0;
            margin: 20px 0 35px;
            display: flex;
            p{
                font-size: 14px;
                color: #19191a;
                padding: 10px 20px;
                font-weight: bold;
                box-sizing: border-box;
            }
            .router-link-active{
                background: #0061FE;
                border-radius: 18px;
                color: #fff;
            }
        }
    }
}

@media screen and (min-width: 1445px) {
    .moreCourse{
        display: none;
    }
    .return{
        display: none;
    }
    .mindCont{
        width: 1200px;
        margin: 0 auto;
        .classify_nav{
            width: 100%;
            height: 84px;
            font-size: 0;
            display: flex;
            align-items: center;
            p{
                color: #19191A;
                font-size: 15px;
                padding: 10px 20px;
                margin-left: 30px;
                cursor: pointer;
                &:first-child{
                    margin-left: 0;
                }
            }
            .router-link-active{
                background: #0061FE;
                border-radius: 18px;
                color: #fff;
            }
        }
    }
    .searchWrap{
        width: 1200px;
        margin: 0 auto;
        // 搜索框
        .inputWrap{
            margin: 110px 0 0;
            padding-bottom: 26px;
            .inputBox{
                input{
                    font-size: 30px;
                    color: #19191a;
                }
            }
            .clearIcon{
                position: absolute;
                right: 0;
                top: 7px;
                cursor: pointer;
            }
            .searchIcon{
                position: absolute;
                top: 50%;
                left: 37%;
                transform: translateY(-50%);
                cursor: pointer;
            }
        }
        .inputBlank{
            width: 1200px;
            height: 800px;
        }
        // 列表
        .listWrap{
            width: 1200px;
            margin: 0 auto;
            li{
                margin: 30px 30px 30px 0;
                width: 31.5%;
                &:nth-child(3n){
                    margin-right: 0;
                }
            }
        }
    }
    .searchCont{
        margin: 0 0 126px;
    }
    // 空白页
    .blank{
        width: 407px;
        margin: 192px auto 356px;
        img{
            width: 407px;
            height: 253px;
        }
        p{
            font-size: 24px;
            color: rgba(25,25,26,0.20);
            margin-top: 22px;
        }
    }
    .page{
        margin: 15px 0 40px;
    }
}
@media screen and (min-width: 1029px) and (max-width: 1440px){
    .moreCourse{
        display: none;
    }
    .return{
        display: none;
    }
    .page{
        margin: 15px 0 40px;
    }
    .mindCont{
        width: 1100px;
        margin: 0 auto;
        .classify_nav{
            width: 100%;
            height: 84px;
            font-size: 0;
            display: flex;
            align-items: center;
            p{
                color: #19191A;
                font-size: 15px;
                padding: 10px 20px;
                margin-left: 30px;
                cursor: pointer;
                &:first-child{
                    margin-left: 0;
                }
            }
            .router-link-active{
                background: #0061FE;
                border-radius: 18px;
                color: #fff;
            }
        }
    }
    .searchWrap{
        width: 1100px;
        margin: 0 auto;
        // 搜索框
        .inputWrap{
            margin: 110px 0 0;
            padding-bottom: 26px;
            .inputBox{
                input{
                    font-size: 30px;
                    color: #19191a;
                }
            }
            .clearIcon{
                position: absolute;
                right: 0;
                top: 7px;
                cursor: pointer;
            }
            .searchIcon{
                position: absolute;
                top: 50%;
                left: 37%;
                transform: translateY(-50%);
                cursor: pointer;
            }
        }
        .inputBlank{
            width: 1100px;
            height: 800px;
        }
        // 列表
        .listWrap{
            width: 1100px;
            margin: 0 auto;
            li{
                margin: 30px 30px 30px 0;
                width: 31.5%;
                &:nth-child(3n){
                    margin-right: 0;
                }
            }
        }
    }
    .searchCont{
        margin: 0 0 126px;
    }
    // 空白页
    .blank{
        width: 407px;
        margin: 192px auto 356px;
        img{
            width: 407px;
            height: 253px;
        }
        p{
            font-size: 24px;
            color: rgba(25,25,26,0.20);
            margin-top: 22px;
        }
    }
}
// 公用
.searchWrap{
    .inputWrap{
        width: 100%;
        display: flex;
        justify-content: space-between;
		align-items: center;
        border-bottom: 2px solid #FAFAFA;
        .inputBox{
            width: 90%;
            margin: 0 auto;
            position: relative;
            input{
                width: 100%;
				height: 40px;
                text-align: center;
            }
        }
        img{
            width: 26px;
            height: 26px;
        }
        p{
            border-radius: 4px;
            line-height: 30px;
            width: 70px;
            text-align: center;
            font-size: 14px;
            color: #fff;
            cursor: pointer;
        }
    }
    .searchCont{
        width: 100%;
        .title{
            font-size: 16px;
            color: rgba(25,25,26,0.80);
            margin-top: 34px;
            span{
                font-size: 12px;
            }
            &:first-child{
                margin-top: 88px;
            }
        }
    }
}
.listWrap{
    display: flex;
    flex-wrap: wrap;
    li{
        .picBox{
            width: 100%;
            height: 250px;
            position: relative;
            img{
                height: 250px;
                width: 100%;
                max-width: 100%;
                border-radius: 16px;
            }
            p{
                background: #0061FE;
                border-radius: 16px 0 16px 0;
                color: #fff;
                width: 63px;
                height: 60px;

                position: absolute;
                right: 0;
                bottom: 0;
                span{
                    display: block;
                    text-align: center;
                }
                span:first-child{
                    font-size: 24px;
                    margin-top: 4px;
                }
                span:last-child{
                    font-size: 12px;
                }
            }
        }
    }
    .infoWrap{
        width: 100%;
        max-width: 100%;
        padding-left: 15px;
        h2{
            font-size: 20px;
            color: #19191A;
            font-weight: bold;
            overflow: hidden; 
            text-overflow: ellipsis;
            white-space: nowrap; 
        }
        .info{
            font-size: 14px;
            color: rgba(25,25,26,0.80);
            display: flex;
            margin: 10px 0 20px;
            p{
                margin-right: 10px;
            }
        }
    }
    .head-zan{
        display: flex;
        align-items: center;
        padding-left: 15px;
        img{
            width: 24px;
            height: 24px;
        }
        .head{
            font-size: 14px;
            color: rgba(25,25,26,0.80);
            img{
                border-radius: 50%;
                margin-right: 10px;
                vertical-align: middle;
            }
        }
        .zan{
            display: flex;
            align-items: center;
            font-size: 12px;
            color: rgba(25,25,26,0.80);
            p{
                width: 24px;
                height: 24px;
                margin: 0 10px 0 30px;
            }
        }
    }
    .category{
        font-size: 12px;
        color: #0061FE;
        margin: 30px 0 20px;
        span{
            margin-right: 10px;
        }
    }
}
// input
input::-webkit-input-placeholder{
    color: rgba(25,25,26,0.20);
}
input::-moz-placeholder{   /* Mozilla Firefox 19+ */
    color: rgba(25,25,26,0.20);
}
input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
    color: rgba(25,25,26,0.20);
}
input:-ms-input-placeholder{  /* Internet Explorer 10-11 */
    color: rgba(25,25,26,0.20);
}
// 清除IE浏览器下会显示的清空键
input[type=text]::-ms-clear{
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/search/Search.vue